import { getCookie } from '@va/util/helpers';
import { useEffect } from 'react';

export function useLoadScriptFromCookie(cookieName: string) {
  useEffect(() => {
    const scriptUrl = getCookie(cookieName);
    if (scriptUrl) {
      const scriptElement = document.createElement('script');
      scriptElement.id = cookieName;
      scriptElement.src = scriptUrl;
      scriptElement.type = 'text/javascript';

      document.body.appendChild(scriptElement);
      return () => {
        if (document.body.contains(scriptElement)) {
          document.body.removeChild(scriptElement);
        }
      };
    }
  }, [cookieName]);

  function callConversionScriptMethod(eventData: Record<string, any>) {
    if (window.twipla_conversion_fct) {
      window.twipla_conversion_fct(eventData);
    }
  }

  return { callConversionScriptMethod };
}
